/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { i as isFunction_1 } from '../../_chunks/dep-8d19eb1a.mjs';
import { i as isString_1 } from '../../_chunks/dep-7f2f03b4.mjs';
import '../../_chunks/dep-eba62589.mjs';
import '../../_chunks/dep-7d9e11c8.mjs';
import '../../_chunks/dep-ae1abe1d.mjs';
import '../../_chunks/dep-16e2f1a5.mjs';
import '../../_chunks/dep-b9567f6a.mjs';
import '../../_chunks/dep-654b4b01.mjs';
import '../../_chunks/dep-a6022780.mjs';

function getTargetElm(elm) {
  if (elm) {
    var _process, _process$env;
    var targetElement = null;
    if (isString_1(elm)) {
      targetElement = document.querySelector(elm);
    } else if (isFunction_1(elm)) {
      targetElement = elm();
    } else {
      throw new Error("elm should be string or function");
    }
    if (targetElement) {
      return targetElement;
    }
    if (((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) !== "test") {
      throw new Error("There is no element with given.");
    }
  } else {
    return document.body;
  }
}

export { getTargetElm as default };
//# sourceMappingURL=getTargetElm.mjs.map
